import React from 'react'
import styled from 'styled-components'
import { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { Snackbar } from '@mui/material';
import ScrollReveal from '../ScrollReveal';

const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
position: relative;
z-index: 1;
align-items: center;
padding: 60px 0;
`

const Wrapper = styled.div`
position: relative;
display: flex;
justify-content: space-between;
align-items: center;
flex-direction: column;
width: 100%;
max-width: 1350px;
padding: 0px 0px 80px 0px;
gap: 12px;
`

const Title = styled.div`
font-size: 42px;
text-align: center;
font-weight: 700;
margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
      font-size: 32px;
  }
`;

const Desc = styled.div`
    font-size: 18px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 28px;
`

const ContactForm = styled.form`
  width: 95%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.card};
  padding: 32px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.border};
  box-shadow: 0 4px 24px ${({ theme }) => theme.glow};
  gap: 12px;
`

const ContactTitle = styled.div`
  font-size: 24px;
  margin-bottom: 6px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
`

const ContactInput = styled.input`
  flex: 1;
  background-color: ${({ theme }) => theme.bgLight};
  border: 1px solid ${({ theme }) => theme.border};
  outline: none;
  font-size: 16px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  transition: border-color 0.2s ease;
  &:focus {
    border: 1px solid ${({ theme }) => theme.primary};
  }
`

const ContactInputMessage = styled.textarea`
  flex: 1;
  background-color: ${({ theme }) => theme.bgLight};
  border: 1px solid ${({ theme }) => theme.border};
  outline: none;
  font-size: 16px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  resize: vertical;
  min-height: 120px;
  transition: border-color 0.2s ease;
  &:focus {
    border: 1px solid ${({ theme }) => theme.primary};
  }
`

const ContactButton = styled.input`
  width: 100%;
  text-align: center;
  background: ${({ theme }) => theme.gradient};
  padding: 14px 16px;
  margin-top: 4px;
  border-radius: 12px;
  border: none;
  color: ${({ theme }) => theme.white};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px ${({ theme }) => theme.glow};
  }
`;

const Contact = () => {
  const [open, setOpen] = React.useState(false);
  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_4lb9lbt', 'template_xyq41kn', form.current, 'be4pR_Ltvjgq81RhG')
      .then((result) => {
        setOpen(true);
        form.current.reset();
      }, (error) => {
        console.log(error.text);
      });
  }

  return (
    <Container id="contact">
      <Wrapper>
        <ScrollReveal direction="down" index={0}>
          <Title>Contact</Title>
        </ScrollReveal>
        <ScrollReveal direction="down" index={1}>
          <Desc>Feel free to reach out to me for any questions or opportunities!</Desc>
        </ScrollReveal>
        <ScrollReveal direction="down" index={2} style={{ width: '100%' }}>
          <FormWrapper>
            <ContactForm ref={form} onSubmit={handleSubmit}>
              <ContactTitle>Email Me</ContactTitle>
              <ContactInput placeholder="Your Email" name="email" type="email" required />
              <ContactInput placeholder="Your Name" name="from_name" required />
              <ContactInput placeholder="Subject" name="subject" required />
              <ContactInputMessage placeholder="Message" rows="4" name="message" required />
              <ContactButton type="submit" value="Send Message" />
            </ContactForm>
          </FormWrapper>
        </ScrollReveal>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message="Email sent successfully!"
        />
      </Wrapper>
    </Container>
  )
}

export default Contact
